import { CursorState } from "../states/CursorState";
import { RenderState } from "../states/RenderState";
import { ScrollState } from "../states/ScrollState";
import { SystemState } from "../states/SystemState";
import { TimeState } from "../states/TimeState";
import { ViewportState } from "../states/ViewportState";

/**
 * Container for global dynamic state used throughout the string-tune system.
 * Provides access to live scroll, viewport, cursor, and render states,
 * which are updated each frame and shared across modules and tools.
 */
export class StringData {
  /**
   * Scroll-related state object.
   * Contains live values like `target`, `current`, `delta`, `direction`, and more.
   * Used for scroll-based animations, transitions, and effects.
   */
  scroll = new ScrollState();

  /**
   * Viewport-related state object.
   * Holds dimensions like window size, content size, aspect ratios, and more.
   * Useful for layout calculations, unit parsing, and element positioning.
   */
  viewport = new ViewportState();

  /**
   * Cursor-related state object.
   * Tracks cursor position, velocity, movement, and derived values.
   * Can be used for pointer interactions, proximity effects, and hover states.
   */
  cursor = new CursorState();

  /**
   * Render-related state object.
   * Stores data related to rendering context (e.g. WebGL, Three.js),
   * such as shared materials, textures, or active render frame data.
   */
  render = new RenderState();

  /**
   * Time-related state object.
   * Tracks frame timings, including current timestamp, delta between frames,
   * and total elapsed time since animation start.
   * Useful for time-based animations, easing, frame consistency, and syncing logic.
   */
  time = new TimeState();

  system = new SystemState();
}
